
/**
 * Utility function to pause async execution. Same as Task.Delay() in c# for async
 * @param {Number} ms - Number of milliseconds to wait
 */
export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}